<template>
  <el-dialog title="首页专辑展示" :visible.sync="visible" width="740px" :before-close="closeCategoryDialog" class="dialog">
    <el-table v-loading="loading" :data="showList" max-height="480" row-key="id">
      <el-table-column label="专辑名称">
        <template slot-scope="{row}">
          <el-select v-model="row.id" size="medium" placeholder="请选择" style="width:260px" @change="setSort(row)">
            <el-option
              v-for="item in selectList"
              :key="item.id"
              :label="item.name"
              :disabled="showList.some(t => t.id === item.id)"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="250px">
        <template slot-scope="{row}">
          <el-input v-model="row.sort" size="medium" controls-position="right" :maxlength="3" :min="1" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140px">
        <template slot-scope="{$index}">
          <el-button type="text" size="medium" @click="deleteHandle($index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button size="medium" type="text" @click="add"><i class="iconfont icon-add-line"></i>添加</el-button>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="setAlbumModulepageShow">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      showList: [],
      selectList: [],
      visible: false,
      loading: false
    }
  },
  created() {
    this.getAlbumModuleSelect()
  },
  methods:{
    show() {
      this.visible = true
      this.getAlbumModulePageShow()
    },
    closeCategoryDialog() {
			this.visible = false
		},
    // 左边选中后循环设置右边的排序
    setSort(row) {
      this.selectList.forEach(t => {
        if (t.id === row.id) this.$set(row, 'sort', t.sort)
      })
    },
    add() {
      this.showList.push({
        id: undefined,
        sort: undefined
      })
    },
    deleteHandle(i) {
      this.showList.splice(i, 1)
    },
    // 专辑下拉
    getAlbumModuleSelect() {
      API.getAlbumModuleSelect().then(res => {
        this.selectList = res.data
      })
    },

    // 首页展示列表
    getAlbumModulePageShow() {
      this.loading = true
      API.getAlbumModulePageShow().then(res => {
        if(res.code !== 10000) return this.$message.error(res.message)
        this.showList = res.data
      }).finally(() => {
        this.loading = false
      })
    },

    // 设置首页展示
    setAlbumModulepageShow() {
      API.setAlbumModulepageShow(this.showList).then(res => {
        this.$message.success('操作成功')
        this.visible = false
      })
    },
    
  }
}
</script>

<style lang="scss" scoped>
.dialog{
  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
}
</style>